export default __webpack_public_path__ + "static/media/arrow-right.e759fd64.svg";